// import Service from '@/service/index.js';
export default {
  props: ['item'],
  data() {
    return {

    };
  },
  created() {
  },
  computed: {
  },
  methods: {

  }
};
